import React from 'react';

const Partner = () => {
  return <div>Partner</div>;
};

export default Partner;
